import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store, persistor } from "./redux/store";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { ThemeProvider } from "./hooks/ThemeProvider";
import PxcPromotionsPortal from "./portals/PxcPromotionsPortal";
import PxcSearchPortal from "./portals/PxcSearchPortal";
import "./i18n/i18n";
import Preloader from "./components/Preloader";

// Function to create and render React root
const renderApp = (containerId, Component) => {
  const container = document.getElementById(containerId);
  if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Router>
              <ThemeProvider>
                <Suspense fallback={<Preloader />}>
                  <Component />
                </Suspense>
              </ThemeProvider>
            </Router>
          </PersistGate>
        </Provider>
      </React.StrictMode>,
    );
  }
};

// Render based on the existence of the containers
renderApp("am-marketplace", App);
renderApp("filter-root", PxcSearchPortal);
renderApp("promotion-root", PxcPromotionsPortal);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
